var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 30,
      height: 40
    },
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0047 39.6346C9.26457 33.3289 -0.498401 24.3776 0.0198263 14.6407C0.867669 6.72464 7.2532 0.572266 15.0047 0.572266C22.7561 0.572266 29.1416 6.72464 29.9895 14.6407C30.3469 25.2724 21.5263 32.6289 15.0047 39.6346Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9799 15.3887C20.9799 18.9429 18.241 21.8242 14.8624 21.8242C11.4838 21.8242 8.74487 18.9429 8.74487 15.3887C8.74487 11.8344 11.4838 8.95312 14.8624 8.95312C18.241 8.95312 20.9799 11.8344 20.9799 15.3887Z",
    fill: "#1D1D1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.56a19cc06f06072160a948fff70a35c1.svg";
export { ForwardRef as ReactComponent };